import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import background from '../../assets/Images/background.PNG';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 overflow-hidden" id="home">
      {/* Background with overlay */}
      <div className="absolute inset-0 overflow-hidden">
        <img 
          src={background} 
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0  bg-black/50" />
      </div>

      {/* Content */}
      <div className="relative container mx-auto px-4 py-16 sm:py-24 md:py-32 lg:py-40 flex items-center min-h-screen">
        <div className="max-w-3xl text-center sm:text-left">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6">
            Smarter Hazard Analysis Starts Here
          </h1>
          <p className="text-lg sm:text-xl text-blue-100 mb-8">
            Identify, Analyze, and Eliminate Operational Risks with an AI-powered, 
            Collaborative HAZOP Study Software designed for high-risk industries.
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 justify-center sm:justify-start">
            <Link to="/login" className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors w-full sm:w-auto">
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
